
import Inspection from "./Inspection.js";
import { SubDomain } from "../SubDomain.js";

export default class InspectionsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Inspection.MODEL_NAME);
    this.storage = storage;
  }

  hasFilter(filter) {
    if (filter) {
      //
    }
    return false;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Inspection(this.domain, item);
      }
    }

    return new Inspection(this.domain);
  }

  findByVehicle(vehicle) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = new Inspection(this.domain, objects[i]);
      if (item.vehicle().idEquals(vehicle)) {
        return item;
      }
    }

    return new Inspection(this.domain);
  }

  /**
   * The newest inspection loaded for this vehicle created between fromMs and toMs, or an
   * empty Inspection when there is none.
   */
  findLatestByVehicleBetween(vehicle, fromMs, toMs) {
    var objects = this.list();
    var latest = new Inspection(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = new Inspection(this.domain, objects[i]);
      if (!item.vehicle().idEquals(vehicle)) {
        continue;
      }
      var created = item.createdDateV2().time();
      if (created < fromMs || created > toMs) {
        continue;
      }
      if (latest.isNew() || created > latest.createdDateV2().time()) {
        latest = item;
      }
    }
    return latest;
  }

  /**
   * The newest pre-trip inspection loaded for this vehicle, or an empty
   * Inspection when none is. Post-trip inspections are skipped.
   */
  findLatestPreTripByVehicle(vehicle) {
    var objects = this.list();
    var latest = new Inspection(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = new Inspection(this.domain, objects[i]);
      if (!item.vehicle().idEquals(vehicle) || !item.isPreTrip()) {
        continue;
      }
      if (latest.isNew() || item.createdDateV2().time() > latest.createdDateV2().time()) {
        latest = item;
      }
    }
    return latest;
  }
}